<section class="stacksBlockContainer" id="block-sidemenu">
  <div id="settingsTabs" *ngIf="checkSettings()">
    <a (click)="showDataTab()" [ngClass]="checkData() ? 'active' : ''">{{ 'Data' | translate }}</a>
    <a (click)="showStyleTab()" [ngClass]="checkStyle() ? 'active' : ''">{{ 'Style' | translate }}</a>
  </div>

  <!-- Sidebar Icon -->
  <div *ngIf="checkSidebar()" class="blockSidebar" (click)="openSettings()">
    <img src="assets/images/blocks/sidemenu.svg" alt="Side Menu" />
    <p>{{ 'Side Menu' | translate }}</p>
  </div>

  <!-- Live preview (top of the settings panel) -->
  <div class="previewSideMenu" *ngIf="checkSettings() && dataValue('useNewDesign')">
    <p class="smPreviewLabel">
      <mat-icon>menu_open</mat-icon>
      {{ 'Side menu for all pages - changes save automatically' | translate }}
      <small class="smSaving" *ngIf="menuItems.saving">{{ 'Saving...' | translate }}</small>
    </p>
 
    <div class="smDrawer" [style]="previewVars()">
      <ng-container *ngIf="dataValue('showDecoration')">
        <div class="smGlow"></div>
        <div class="smCorner"></div>
      </ng-container>

      <div class="smHeader">
        <span class="smClose"><mat-icon>close</mat-icon></span>
      </div>

      <div class="smBody">
        <div class="smIntro">
          <div class="smLogo" [class.hasImage]="dataValue('logo')" *ngIf="dataValue('showLogo')">
            <img *ngIf="dataValue('logo')" [src]="dataValue('logo')" alt="" />
            <mat-icon *ngIf="!dataValue('logo')">image</mat-icon>
          </div>
          <ng-container *ngIf="dataValue('showTitle')">
            <h3 class="smTitle">{{ dataValue('title') }}</h3>
            <p class="smSubtitle">{{ dataValue('subtitle') }}</p>
          </ng-container>
        </div>

        <div class="smNav">
          <div class="smCard" *ngFor="let item of previewItems">
            <span class="smCardStart">
              <span class="smCardIcon"><img [src]="dataValue('itemIcon') || defaultItemIcon" alt="" /></span>
              <span class="smCardLabel">{{ item }}</span>
            </span>
            <span class="smCardArrow"><mat-icon>chevron_right</mat-icon></span>
          </div>
        </div>

        <div class="smSocial" *ngIf="dataValue('showSocial')">
          <p>{{ dataValue('socialTitle') }}</p>
          <div class="smSocialRow">
            <span class="smSocialBtn" *ngFor="let n of [1, 2, 3, 4]"></span>
          </div>
          <small>{{ 'Uses the Floating Social links from the footer' | translate }}</small>
        </div>
      </div>

      <div class="smFooter" *ngIf="dataValue('showUserFooter')">
        <div class="smUser">
          <span class="smAvatar"><mat-icon>person</mat-icon></span>
          <span>
            <span class="smHello">{{ dataValue('welcomeText') }}</span>
            <span class="smName">{{ 'User Name' | translate }}</span>
          </span>
        </div>
        <span class="smLogout"><mat-icon>logout</mat-icon></span>
      </div>
    </div>
  </div>

  <!-- Data Tab -->
  <div class="previewFields" *ngIf="checkData()">
    <div class="sectionSettings smDesignSwitch">
      <mat-checkbox color="primary" (change)="dataChange('useNewDesign', blockId, $event, 'toggle')" [checked]="dataValue('useNewDesign') === true">
        {{ 'Use new side menu design' | translate }}
      </mat-checkbox>
      <p class="smHint">{{ 'Off: the app keeps the classic side menu. On: the new design below is used.' | translate }}</p>
    </div>

    <div class="sectionSettings">
      <div class="sectionHeader">
        {{ 'Menu Items' | translate }}
        <small class="smSaving" *ngIf="menuItems.saving">{{ 'Saving...' | translate }}</small>
      </div>
      <p class="smHint">{{ 'Menu items are the same on all pages.' | translate }}</p>

      <mat-progress-bar mode="indeterminate" *ngIf="!menuItems.loaded"></mat-progress-bar>

      <div class="smItems" cdkDropList (cdkDropListDropped)="menuItemDrop($event)" *ngIf="menuItems.loaded">
        <div class="smItem" *ngFor="let item of menuItems.items; let i = index" cdkDrag>
          <div class="smItemTop">
            <mat-icon class="smDragHandle" cdkDragHandle>drag_indicator</mat-icon>
            <mat-form-field appearance="outline" class="smItemName">
              <mat-label>{{ 'Name' | translate }}</mat-label>
              <input matInput [value]="item.name" (keyup)="menuItems.update(i, { name: $any($event.target).value })" />
            </mat-form-field>
            <button type="button" class="smIconBtn" (click)="menuItems.remove(i)" [title]="'Delete' | translate">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Link Type' | translate }}</mat-label>
            <mat-select [value]="item.link" (selectionChange)="menuItems.update(i, { link: $event.value })">
              <mat-option *ngFor="let type of menuItems.linkTypes" [value]="type.value">{{ type.label | translate }}</mat-option>
              <mat-option *ngFor="let customView of builderService.customViews" [value]="customView.view_name">{{ customView.view_name }}</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field appearance="outline" *ngIf="item.link === 'externalURL'">
            <mat-label>{{ 'URL' | translate }}</mat-label>
            <input matInput placeholder="https://" [value]="item.externalURL || ''" (keyup)="menuItems.update(i, { externalURL: $any($event.target).value })" />
          </mat-form-field>
        </div>
      </div>

      <div class="smNewItem">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Menu Name' | translate }}</mat-label>
          <input matInput [(ngModel)]="newItemName" (keyup.enter)="addMenuItem()" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'Link Type' | translate }}</mat-label>
          <mat-select [(ngModel)]="newItemLink">
            <mat-option *ngFor="let type of menuItems.linkTypes" [value]="type.value">{{ type.label | translate }}</mat-option>
            <mat-option *ngFor="let customView of builderService.customViews" [value]="customView.view_name">{{ customView.view_name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <button type="button" class="stacksBtn green" (click)="addMenuItem()" [disabled]="!newItemName.trim()">
          <mat-icon>add</mat-icon>
          {{ 'Add Menu' | translate }}
        </button>
      </div>
    </div>

    <ng-container *ngIf="dataValue('useNewDesign')">
    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Texts' | translate }}</div>
      <ul>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Title' | translate }}</mat-label>
            <input matInput [value]="dataValue('title') || ''" (keyup)="dataChange('title', blockId, $event, 'text')" />
          </mat-form-field>
        </li>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Subtitle' | translate }}</mat-label>
            <textarea matInput rows="3" [value]="dataValue('subtitle') || ''" (keyup)="dataChange('subtitle', blockId, $event, 'text')"></textarea>
          </mat-form-field>
        </li>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Social Links Title' | translate }}</mat-label>
            <input matInput [value]="dataValue('socialTitle') || ''" (keyup)="dataChange('socialTitle', blockId, $event, 'text')" />
          </mat-form-field>
        </li>
        <li>
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Welcome Text' | translate }}</mat-label>
            <input matInput [value]="dataValue('welcomeText') || ''" (keyup)="dataChange('welcomeText', blockId, $event, 'text')" />
          </mat-form-field>
        </li>
      </ul>
    </div>

    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Show / Hide' | translate }}</div>
      <ul>
        <li *ngFor="let field of visibilityFields">
          <mat-slide-toggle (change)="dataChange(field.key, blockId, $event, 'toggle')" [checked]="dataValue(field.key)">
            <span>{{ field.label | translate }}</span>
          </mat-slide-toggle>
        </li>
      </ul>
    </div>

    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Item Icon' | translate }}</div>
      <ul>
        <li class="smIconField">
          <img class="smIconPreview" [src]="dataValue('itemIcon') || defaultItemIcon" alt="" />
          <label class="fileUpload" for="sideMenuItemIcon">
            {{ 'Choose an Icon' | translate }}
            <input type="file" id="sideMenuItemIcon" accept="image/*" (change)="processImage($event, 'itemIcon')" />
          </label>
          <button type="button" class="stacksBtn red" *ngIf="dataValue('itemIcon')" (click)="removeImage('itemIcon')">
            <mat-icon>restart_alt</mat-icon>
            {{ 'Use Default' | translate }}
          </button>
        </li>
      </ul>
    </div>

    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Logo' | translate }}</div>
      <p class="smHint">{{ 'Shown at the top of the side menu. If empty, the app uses the header image.' | translate }}</p>
      <ul>
        <li class="smIconField">
          <img class="smLogoPreview" *ngIf="dataValue('logo')" [src]="dataValue('logo')" alt="" />
          <label class="fileUpload" for="sideMenuLogo">
            {{ 'Choose a Logo' | translate }}
            <input type="file" id="sideMenuLogo" accept="image/*" (change)="processImage($event, 'logo')" />
          </label>
          <button type="button" class="stacksBtn red" *ngIf="dataValue('logo')" (click)="removeImage('logo')">
            <mat-icon>delete_outline</mat-icon>
            {{ 'Remove' | translate }}
          </button>
        </li>
      </ul>
    </div>
    </ng-container>
  </div>

  <!-- Style Tab -->
  <div class="styleFields" *ngIf="checkStyle()">
    <p class="smHint smOffNote" *ngIf="!dataValue('useNewDesign')">{{ 'Turn on Use new side menu design in the Data tab to change colors and size.' | translate }}</p>
    <ng-container *ngIf="dataValue('useNewDesign')">
    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Colors' | translate }}</div>
      <ul>
        <li class="contentContainerColor" *ngFor="let field of colorFields">
          <label>{{ field.label | translate }}</label>
          <mat-form-field>
            <p class="colorPickerValue">{{ styleValue(field.key) || ('Default' | translate) }}</p>
            <label [for]="'sideMenu-' + field.key" class="colorLabel">
              <input
                type="color"
                [id]="'sideMenu-' + field.key"
                matInput
                class="colorPicker"
                [name]="'sideMenu-' + field.key"
                (change)="colorChange(field.key, blockId, $event)"
                [value]="styleValue(field.key) || colorFallback(field.key)"
              />
            </label>
          </mat-form-field>
          <button type="button" class="smResetColor" *ngIf="styleValue(field.key)" (click)="resetColor(field.key, blockId)" [title]="'Use Default' | translate">
            <mat-icon>restart_alt</mat-icon>
          </button>
        </li>
      </ul>
    </div>

    <div class="sectionSettings">
      <div class="sectionHeader">{{ 'Size' | translate }}</div>
      <ul>
        <li>
          <mat-label>{{ 'Max Width (px)' | translate }}</mat-label>
          <mat-slider showTickMarks discrete max="600" min="240" step="10" thumbLabel="true">
            <input matSliderThumb ngModel="{{ styleValue('maxWidth', '450') }}" (change)="widthChange(blockId, $event)" />
          </mat-slider>
          <small class="smHint">{{ 'On phones the menu takes 85% of the screen, up to this width.' | translate }}</small>
        </li>
      </ul>
    </div>
    </ng-container>
  </div>
</section>
